import { LegalLayout, H1, H2, P, UL } from "./LegalLayout";

export const TermsPage = ({ scrollTo }) => (
  <LegalLayout scrollTo={scrollTo} kind="terms" updated="December 2025">
    <H1>Terms of Use</H1>
    <P>
      By using drinkdunc.com, you agree to these terms. They&apos;re short. Please
      read them.
    </P>

    <H2>1. About DUNC</H2>
    <P>
      DUNC is a modern sparkling kombucha brand from India. This website
      introduces the brand and lets you connect with us for early tasting via the
      Founder&apos;s Batch / First Sip programme. No ecommerce transactions are
      processed on this site today.
    </P>

    <H2>2. Content</H2>
    <UL items={[
      "All logos, product names, imagery, copy and design are the property of DUNC (or licensed to us).",
      "You may not copy, redistribute, or use them commercially without our written permission.",
      "You may share links to our pages, quote us in the context of journalism, and screenshot us onto Instagram (please tag us).",
    ]} />

    <H2>3. First Sip / Founder&apos;s Batch</H2>
    <UL items={[
      "Founder's Batch tastings are extended by invitation and in limited quantities, at our sole discretion.",
      "Availability may be limited to specific cities or regions.",
      "Nothing on this site constitutes an offer to sell alcohol. DUNC is a non-alcoholic sparkling kombucha.",
    ]} />

    <H2>4. Your responsibilities</H2>
    <UL items={[
      "Provide accurate contact information when you sign up or write to us.",
      "Don't try to disrupt, scrape, overload or reverse-engineer the site.",
      "Don't attempt unauthorised access to our systems or other users' data.",
    ]} />

    <H2>5. No warranties on beverage claims</H2>
    <P>
      We describe DUNC honestly. We don&apos;t make medical, therapeutic or
      curative claims. Nothing on this site is medical advice. If you have a
      health condition, allergy, or you&apos;re pregnant, please consult a
      qualified professional before adding any new beverage to your routine.
    </P>

    <H2>6. Liability</H2>
    <P>
      To the maximum extent permitted by law, DUNC is not liable for indirect or
      consequential loss arising from your use of this site. The site is
      provided &ldquo;as is&rdquo;. We&apos;ll do our best to keep it running,
      but we don&apos;t promise it&apos;ll be error-free.
    </P>

    <H2>7. Governing law</H2>
    <P>
      These terms are governed by the laws of India. Any disputes will be
      resolved in the competent courts of Bengaluru, India.
    </P>

    <H2>8. Contact</H2>
    <P>
      Questions? WhatsApp us at{" "}
      <a
        href="https://wa.me/919901234981"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#D9A441] underline decoration-white/20 underline-offset-4"
      >
        +91 990 1234 981
      </a>.
    </P>
  </LegalLayout>
);

export default TermsPage;
